// extracted by mini-css-extract-plugin
module.exports = {"titre":"Titre_titre__1O6a9","mobile":"Titre_mobile__3jgkM","desktop":"Titre_desktop__30Gld"};